module.exports = "/LikeActive@2x-cc92d32b3af06831d00bb0d9c7a63951.png";